import {
  Skull,
  Flame,
  Ghost,
  Bird,
  Cat,
  Dog,
  Fish,
  Bug,
  Dna,
  Bot,
  Trees,
  Mountain,
  Swords,
  Castle,
  Gem,
  Leaf,
  Scroll,
  BookOpen,
  Landmark,
  Sparkle,
  Sprout,
  Squirrel
} from 'lucide-react';

export const KINDRED_ICONS = {
  "angels": <Bird />,
  "cats": <Cat />,
  "dogs": <Dog />,
  "dragons": <Flame />,
  "elves": <Leaf />,
  "goblins": <Bug />,
  "humans": <Skull />,
  "merfolk": <Fish />,
  "spirits": <Ghost />,
  "zombies": <Skull />,
  "robots": <Bot />,
  "satyrs": <Sprout />,
  "vampires": <Sparkle />,
  "phyrexians": <Dna />,
  "dinosaurs": <Dna />,
  "slivers": <Bot />,
  "knights": <Swords />,
  "soldiers": <Castle />,
  "elementals": <Trees />,
  "hydras": <Mountain />,
  "squirrels": <Squirrel />
};

export const TYPAL_ICONS = {
  "artifacts": <Gem />,
  "enchantments": <Scroll />,
  "lands": <Landmark />,
  "planeswalkers": <BookOpen />,
  "spells": <Sparkle />
};
